import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getPermissionList = store => store[NAME].permissionList;
export const getTypeList = store => store[NAME].typeList;
export const getHasBotAssistant = store => store[NAME].hasBotAssistant;
